// React
import { useCallback } from 'react';
import { useLoaderData } from 'react-router-dom';

// Hooks
import { usePreviewData } from '@/hooks/usePreviewData';

// Services
import { getHeader } from '@/services/header/headerService';
import { getFooter } from '@/services/footer/footerService';

// Components
import LayoutHeaderFooter from '@/components/layout/LayoutHeaderFooter/LayoutHeaderFooter';

// Styles
import styles from './Blog.module.css';

export async function blogListingLoader() {
  const [header, footer] = await Promise.all([getHeader(), getFooter()]);

  return {
    header,
    footer,
  };
}

function Blog() {
  const loaderData = useLoaderData() as Awaited<ReturnType<typeof blogListingLoader>>;
  const refetch = useCallback(() => blogListingLoader(), []);
  const data = usePreviewData(loaderData, refetch);

  if (!data) return null;

  const { header, footer } = data;

  return (
    <main>
      <LayoutHeaderFooter header={header} footer={footer}>
        <div className={styles.body}>blog</div>
      </LayoutHeaderFooter>
    </main>
  );
}

export default Blog;
